import React, { PropTypes } from 'react';

import styled from 'styled-components';

const Bold = styled.span`
  font-family: ${props => props.theme.font.bold};
  color: ${props => props.theme.color.secondary};
  text-transform: uppercase;
`;

const ColumnBold = ({ data }) => {
  return <Bold>{data}</Bold>;
};

export default ColumnBold;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/ColumnBold.js